import { FlexStyle } from 'react-native';
import Colors from '../../constants/Colors';
import { HappyScoreCategory, NotificationType, TicketStatus } from '../../constants/Types';
import { AppScreen } from '../../navigation/LinkingConfiguration';

export const getCategoryScreen = (category: HappyScoreCategory) => {
  if (category === HappyScoreCategory.INTERNAL_ENVIRONMENT) return AppScreen.INTERNAL_ENVIRONMENT;
  if (category === HappyScoreCategory.EXTERNAL_ENVIRONMENT) return AppScreen.EXTERNAL_ENVIRONMENT;
  if (category === HappyScoreCategory.ENERGY) return AppScreen.ENERGY;
  if (category === HappyScoreCategory.OCCUPANCY) return AppScreen.OCCUPANCY;
  if (category === HappyScoreCategory.AMENITIES) return AppScreen.AMENITIES;
  if (category === HappyScoreCategory.ERGONOMICS) return AppScreen.ERGONOMICS;
  if (category === HappyScoreCategory.SATISFACTION) return AppScreen.SATISFACTION;
  if (category === HappyScoreCategory.IT) return AppScreen.IT;
  if (category === HappyScoreCategory.HAPPY_SCORE) return AppScreen.HOME;
  return AppScreen.USER_MANAGEMENT;
};

export type Notification = {
  id: string,
  type: string,
  timestamp: string,
  title: string,
  description: string,
  priority: number,
  isRead: boolean,
  status?: TicketStatus,
  severity?: number,
  ticketId?: string,
  clientId?: string,
  category?: HappyScoreCategory,
  dropdownView?: boolean,
  buildingName: string,
  style?: FlexStyle,
  expanded?: boolean,
  buildingId: string,
  email?: string,
}

export const getNotificationData = (notificationList) => (notificationList
  ?.length > 0 ? notificationList?.map((notification) => ({
    type: notification['notification-type'],
    timestamp: notification.timestamp,
    title: notification['notification-title'],
    description: notification['markdown-content'] ?? notification['notification-body'],
    priority: parseInt(`${1 + notification['notification-priority']}`, 10),
    status: notification['solve-status'],
    reportId: notification['solve-issueid'],
    buildingName: notification['solve-buildingname'],
    category: notification['notification-category'],
    severity: parseInt(`${notification.severity ?? 3}`, 10),
    isRead: notification['is-read'] === true || notification['is-read'] === 'true',
    id: notification.id,
    buildingId: notification['solve-buildingid'],
    ticketId: notification['solve-issueid'],
    clientId: notification.clientid,
    email: notification['notification-receiver-email'],
  })) ?? [] : []);

export const getNotificationHeaderText = (itemType: string) => {
  if (itemType === NotificationType.RAISED) return 'TICKET RAISED';
  if (itemType === NotificationType.UPDATE) return 'TICKET UPDATE';
  if (itemType === NotificationType.ANOMALY) return 'ANOMALY';
  if (itemType === NotificationType.ALERT) return 'ALERT';
  if (itemType === NotificationType.INSIGHT) return 'INSIGHT';
  return null;
};

export const getNotificationBorderColor = (itemType: string) => {
  if (itemType === NotificationType.ALERT) return Colors.light.hereworksRed;
  if (itemType === NotificationType.ANOMALY) return Colors.light.hereworksBlue500;
  if (itemType === NotificationType.INSIGHT) return Colors.light.hereworksYellow500;
  return Colors.light.hereworksDarkBlue;
};

export const getNotificationHeaderColor = (itemType: string) => {
  if (itemType === NotificationType.ALERT) return Colors.light.hereworksRed;
  if (itemType === NotificationType.ANOMALY) return Colors.light.hereworksBlue500;
  if (itemType === NotificationType.INSIGHT) return Colors.light.hereworksDarkYellow700;
  return Colors.light.hereworksBlack600;
};

export const getNotificationStatusColor = (ticketStatus: TicketStatus) => {
  if (ticketStatus === TicketStatus.REPORTED) return Colors.light.hereworksDarkBlue;
  if (ticketStatus === TicketStatus.INPROGRESS) return Colors.light.hereworksBlue500;
  if (ticketStatus === TicketStatus.PAUSED) return Colors.light.hereworksDarkYellow700;
  if (ticketStatus === TicketStatus.COMPLETED) return Colors.light.hereworksGreen500;
  if (ticketStatus === TicketStatus.REOPENED) return Colors.light.hereworksBlue500;
  return Colors.light.hereworksDarkBlue;
};

export const getNotificationStatusBackgroundColor = (ticketStatus: TicketStatus) => {
  if (ticketStatus === TicketStatus.PAUSED) return Colors.light.hereworksYellow50;
  if (ticketStatus === TicketStatus.COMPLETED) return Colors.light.hereworksGreen50;
  return Colors.light.hereworksWhite500;
};

export const getStatusFlagIconBorderColor = (ticketStatus: TicketStatus) => {
  if (ticketStatus === TicketStatus.INPROGRESS) return Colors.light.hereworksDarkBlue200;
  if (ticketStatus === TicketStatus.PAUSED) return Colors.light.hereworksYellow200;
  if (ticketStatus === TicketStatus.COMPLETED) return Colors.light.hereworksGreen100;
  if (ticketStatus === TicketStatus.REOPENED) return Colors.light.hereworksBlue100;
  return Colors.light.hereworksBlack100;
};

export const getNotificationStatusText = (ticketStatus: TicketStatus) => {
  if (ticketStatus === TicketStatus.REPORTED) return 'Raised';
  if (ticketStatus === TicketStatus.INPROGRESS) return 'In progress';
  if (ticketStatus === TicketStatus.PAUSED) return 'Paused';
  if (ticketStatus === TicketStatus.COMPLETED) return 'Resolved';
  if (ticketStatus === TicketStatus.REOPENED) return 'Re-opened';
  return '';
};

const months: string[] = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

export const getNotificationTime = (dateString: string) => {
  const date: Date = new Date(dateString);
  return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}, at `
    + `${date.getHours() < 10 ? '0' : ''}${date.getHours()}:`
    + `${date.getMinutes() >= 10 ? '' : '0'}${date.getMinutes()}`;
};
